import axios from "axios";
import * as AppSettingsService from "../../../services/AppSettingsService";
import { ITripDetails } from "../Interfaces/ITripDetails";
import { WandaTripStatus } from "../../../types/ApplicationTypes";
const appSettings = AppSettingsService;

export async function getTripDetails(
  personId: number
): Promise<Array<ITripDetails>> {
  try {
    let wandaStatusid =
      WandaTripStatus.Booked + "," + WandaTripStatus.Completed;
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/GetWandaTripWithPagination?PersonId=${personId}&skipPagination=true&wandaTripStatusIds=${wandaStatusid}`
    );
    return response.data?.personTrips;
  } catch (error) {
    throw error;
  }
}
